export default __webpack_public_path__ + "static/media/028-couple-1.e23fb7c8.png";